import React from "react";

export const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const data = payload[0].payload;
  const isOrg = data.isOrg;
  const color = isOrg ? "#6b7280" : data.department.color || "#6b7280";
  const title = isOrg ? data.name : data.department.name;

  return (
    <div className="bg-white dark:bg-gray-800 p-3 shadow-lg border rounded">
      <p className="font-medium mb-2" style={{ color }}>
        {title}
      </p>
      <div className="space-y-1 text-sm">
        <p>Acknowledged : {data.x?.toFixed(1)}%</p>
        <p>Logged: {data.y?.toFixed(1)}%</p>
      </div>
    </div>
  );
};
